<script>
  import { _ } from "./i18n.js";
  import {
    Page,
    BlockTitle,
    Block,
    Button,
    Icon,
    Card,
    CardContent,
    CardHeader,
    Link,
    List,
    ListItem
  } from "framework7-svelte";
  import Toolbar from "./Toolbar.svelte";
</script>

<Page>
  <div class="page-content">
    <div style="text-align: center">
      <BlockTitle medium>{$_('about.title')}</BlockTitle>

      <div style="margin-top: 40px;">
        <span style="font-size: 2.5rem; color: red" class="icon icon-pain" />
        <div>{$_('about.noCarryBottles')}</div>
      </div>

      <div style="margin-top: 40px;">
        <span
          style="font-size: 2.5rem; color: rgb(0, 122, 255);"
          class="icon icon-delivery" />
        <div>{$_('about.within90min')}</div>
      </div>

      <div style="margin-top: 40px;">
        <span
          style="font-size: 2.5rem; color: #DAA520"
          class="icon icon-quality" />
        <div>{$_('about.waterQuality')}</div>
      </div>
    </div>

    <Card style="margin-top: 60px" expandable backdrop={false}>
      <CardContent padding={false}>
        <div class="bg-color-blue" style="height: 300px">
          <CardHeader
            textColor="white"
            style="height: 100%"
            class="display-block">
            {$_('about.faqs')}
            <div
              style="position: absolute; font-size: 4rem; top: 50%;left: 50%;
              transform: translate(-50%, -50%);">
              <span class="icon icon-question" />
            </div>
          </CardHeader>
          <Link
            cardClose
            color="white"
            class="card-opened-fade-in"
            style="position: absolute; right: 15px; top: 15px; font-size: 2rem"
            icon="icon icon-close" />
        </div>
        <div class="card-content-padding">
          <div class="page-content">
            <div>
              <div style="font-weight: bold">
                {$_('about.faq.whereToSend.q')}
              </div>
              {$_('about.faq.whereToSend.a')}
            </div>
            <div>
              <div style="margin-top: 20px; font-weight: bold">
                {$_('about.faq.openingTimes.q')}
              </div>
              {$_('about.faq.openingTimes.a')}
            </div>
            <div>
              <div style="margin-top: 20px; font-weight: bold">
                {$_('about.faq.howFast.q')}
              </div>
              {$_('about.faq.howFast.a')}
            </div>
            <div>
              <div style="margin-top: 20px; font-weight: bold">
                {$_('about.faq.howToPay.q')}
              </div>
              {$_('about.faq.howToPay.a')}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>

    <img
      style="width: 100%; margin-top: 40px; margin-bottom: 20px"
      alt="Tueyhom Delivery by Sea Eagle"
      src="https://lh3.googleusercontent.com/Blw-BqBC-59xweuZjNHANar_eg9UFKx8uF4erDSMYhrTMLGIz45Zrgu3YZCnqqGOFT5CYnuKJPpEbfz5ZeAU4xMPXE484jANHoy4lhWa4oKnAYqfEDqM5KIzcDy3boD6rPpmEzPWxfklP5Iomsi-zlfkWVXwNF3zK4CiMepuhlPDs9t2MKTzqVrlIJJ-vWuJak5SCSxnOsA-l3m93JKaVMe5_nFl3bQl-qkkWr2BFHuAdk0omNmPGMVkd3i-je0-9JsBeozxjoZ02qz1ie_qhViwd596HijurK_EWhN9g1OHCq0mfQaT4x2ji4M-h8H3hPZyexGJROH14VONL0xIa7G5m4f1dblgPfTAQL79Ao1TvY0-n8tSkHHHgJGZgIV-JXJt5viEycMDfn45giKRWP6twFc1aHWBRmll5rsf66s7nIDmnmx-1_PszgYVT2EfhHm7kkuaqkUdz3qIHr8zAKoQ929fp29TbkSxfbBMNeUzOcHXjagdFCHYrCJhSgdtbTmXMwuaPt4gEgl_rcK0ttC3wwGeuOJI__a4LB9-zLmHUy6d-MPlKkfSfwFamlxz4-c0CURg1TTPATr35I2QZqg2Wh5_R_ZAjdg_6cBH10hx8peWCkvTfuoNe4JwJZOenNjSbKA1CuLFUdJLmOf_-5-RCdlawmxg86qXotcSTu-s7FZxgyIWRgQprrOTo5hRfPW_W4abuVTaMVszBvjFKOFSVHTAqpPYjZxZKTOxRIB7r-B7N5DaKhU=s1000" />

    <BlockTitle medium>{$_('about.links')}</BlockTitle>

    <List>
      <ListItem link="/Terms" title={$_('terms.title')}>
        <span
          style="color: rgb(0, 122, 255); font-size: 22px"
          slot="media"
          class="icon icon-external" />
      </ListItem>
      <ListItem
        link="https://www.facebook.com/TUEYHOM.INDUSTRY"
        target="_blank"
        external
        title={$_('about.tueyhom')}>
        <span
          style="color: rgb(0, 122, 255); font-size: 22px"
          slot="media"
          class="icon icon-external" />
      </ListItem>
      <ListItem
        link="https://www.seaeagletour.com"
        target="_blank"
        external
        title={$_('about.seaeagle')}>
        <span
          style="color: rgb(0, 122, 255); font-size: 22px"
          slot="media"
          class="icon icon-external" />
      </ListItem>
      <ListItem
        link="https://line.me/ti/p/mp7S1wElsR"
        target="_blank"
        external
        title={$_('about.contactDev')}>
        <span
          slot="media"
          style="color: rgb(0,157,0); font-size: 22px"
          class="icon icon-line" />

        <div slot="after" style="color: rgb(0,157,0); font-size: 22px">
          <img
            style="max-width: 40px; border-radius: 50%; margin-right: 10px"
            alt="User Profile"
            src="https://profile.line-scdn.net/0hNHvFH35ZEWdLPzm4UJFuMHd6Hwo8ERcvM10MATxqSANgWlJmdA5ZAm43TAVgWwJhdgpcBms9GwQ2" />
        </div>
      </ListItem>
    </List>

    <div style="color: rgb(0, 122, 255); text-align: center; padding: 20px">
      {$_('about.copyright', { values: { year: new Date().getFullYear() } })}
    </div>
  </div>

  <Toolbar tabLinkActive={'/About'} />
</Page>
